<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" layout="vertical">
        <a-row>
          <a-col span="24">
            <a-form-item label="是否启用">
              <a-radio-group
                v-decorator="[
                  'isOpen',
                  {
                    rules: [{ required: true, message: '请选择是否启用' }]
                  }
                ]"
              >
                <a-radio :value="0">
                  否
                </a-radio>
                <a-radio :value="1">
                  是
                </a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="分红产品">
              <a-select
                show-search
                style="width: 300px"
                placeholder="请选择分红产品"
                @change="codeChange"
                v-decorator="[
                  'fundCode',
                  {
                    rules: [{ required: true, message: '请选择分红产品' }]
                  }
                ]"
              >
                <a-select-option
                  v-for="(item, index) in fundList"
                  :key="index"
                  :value="item.fundCode"
                >
                  {{ item.fundCode }} / {{ item.fundName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-show="false" label="产品代码">
              <a-input
                placeholder="请输入产品代码"
                v-decorator="['fundName']"
              ></a-input>
            </a-form-item>
            <!--            <a-form-item v-show="false" label="产品代码">-->
            <!--              <a-input placeholder="请输入产品代码" v-decorator="['fundCode']"></a-input>-->
            <!--            </a-form-item>-->
            <!--            <a-form-item v-show="false" label="产品名称">-->
            <!--                <a-input style="width: 300px" disabled placeholder="请输入产品名称" v-decorator="['fundName']"></a-input>-->
            <!--            </a-form-item>-->
          </a-col>
          <a-col span="12">
            <a-form-item label="分配方式">
              <a-select
                placeholder="请选择分配方式"
                style="width: 300px"
                v-decorator="[
                  'allotType',
                  {
                    rules: [{ required: true, message: '请选择分配方式' }]
                  }
                ]"
              >
                <a-select-option
                  :value="item.value"
                  v-for="(item, index) in allot_type"
                  :key="index"
                >
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="单位分红">
              <a-input
                style="width: 300px"
                placeholder="请输入单位分红"
                v-decorator="[
                  'unitProfit',
                  {
                    rules: [
                      { required: true, message: '请请输入单位分红' },
                      {
                        required: false,
                        pattern: new RegExp(/^\d+(\.\d+)?$/, 'g'),
                        message: '只能输入非负数值'
                      }
                    ]
                  }
                ]"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="登记日">
              <a-date-picker
                style="width: 300px"
                format="YYYY-MM-DD"
                value-format="yyyy-MM-dd"
                v-decorator="[
                  'recordDate',
                  {
                    rules: [{ required: true, message: '请选择登记日' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="除息日">
              <a-date-picker
                style="width: 300px"
                format="YYYY-MM-DD"
                value-format="yyyy-MM-dd"
                v-decorator="[
                  'exDividendDate',
                  {
                    rules: [{ required: true, message: '请选择除息日' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="红利发放日">
              <a-date-picker
                style="width: 300px"
                format="YYYY-MM-DD"
                value-format="yyyy-MM-dd"
                v-decorator="[
                  'paymentDate',
                  {
                    rules: [{ required: true, message: '请选择现金红利发放日' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import pick from 'lodash.pick';
import { validateDuplicateValue } from '@/utils/util';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import 'tinymce/icons/default/icons.min';
import JImageUpload from '@/components/jeecg/JImageUpload';
import JUpload from '@/components/jeecg/JUpload';
import { httpAction } from '@/api/manage';
import { queryByFundCode } from '@/api/api';
import moment from 'moment';

const validateFh = (rule, value, callback) => {
  if (value == '') {
    callback(new Error('请输入单位分红'));
  }
  if (isNaN(value.toString().replace(/\d*\.\d*/g, ''))) {
    callback(new Error('只能输入数值'));
  }
  callback();
};
export default {
  name: 'bonusManageModal',
  components: {
    JDictSelectTag,
    JImageUpload,
    JUpload
  },
  props: ['share_type', 'allot_type'],
  data() {
    return {
      form: this.$form.createForm(this),
      title: '修改',
      width: 800,
      visible: false,
      model: {},
      validateFh,
      fundList: [],
      confirmLoading: false,
      url: {
        add:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productsFundBonus/add',
        edit:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productsFundBonus/edit'
      }
    };
  },
  created() {
    this.initdata();
  },
  methods: {
    moment,
    codeChange(value, option) {
      const index = option.data.key;
      let fundName = this.fundList[index].fundName;
      let fundCode = this.fundList[index].fundCode;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          fundName,
          fundCode
        });
      });
    },
    initdata() {
      queryByFundCode().then(res => {
        if (res.code === 200) {
          this.fundList = res.result;
        }
      });
    },
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      if (record.id) {
        // record.isOpen = record.isOpen === 1 ? true : false;
        record.recordDate = moment(record.recordDate, 'YYYY-MM-DD');
        record.exDividendDate = moment(record.exDividendDate, 'YYYY-MM-DD');
        record.paymentDate = moment(record.paymentDate, 'YYYY-MM-DD');
      }
      this.model = Object.assign({}, record);
      this.visible = true;

      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'fundCode',
            'fundName',
            'noticeId',
            'isOpen',
            'projectName',
            'shareYear',
            'unitProfit',
            'allotType',
            'shareType',
            'recordDate',
            'exDividendDate',
            'paymentDate'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let timeObj = {
            recordDate: moment(values.recordDate).format('YYYYMMDD'),
            exDividendDate: moment(values.exDividendDate).format('YYYYMMDD'),
            paymentDate: moment(values.paymentDate).format('YYYYMMDD')
          };
          let formData = Object.assign(this.model, values, timeObj);
          console.log(formData);
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'fundCode',
          'fundName',
          'noticeId',
          'isOpen',
          'projectName',
          'shareYear',
          'allotType',
          'unitProfit',
          'shareType',
          'recordDate',
          'exDividendDate',
          'paymentDate'
        )
      );
    }
  }
};
</script>
<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
